import React from 'react';
import { cn } from '../../utils/cn'; // classNames utility
import Button from './Button';
import { ArrowRightIcon } from 'lucide-react';
import Typography from './Typography';

const DomainCard = ({ image, tag, domain, price, hideTag = false }) => {
  return (
    <div className="relative overflow-hidden group domain-card">
      <img
        src={image}
        alt={domain}
        className="w-full h-60 object-cover transition-transform duration-300 group-hover:scale-105"
      />

      {!hideTag && <div className="absolute top-3 left-3 bg-white text-black text-xs px-2 py-1 rounded">
        {tag}
      </div>}

      <div className="absolute bottom-4 group-hover:bottom-12 left-4 text-white">
        <p className="text-lg font-semibold">{domain}</p>
        <p className="text-base font-medium">{price}</p>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-0 bg-black/60 opacity-0 group-hover:h-9 group-hover:opacity-100 transition-all duration-300 flex items-center justify-start">
        <Button isLink={true} linkProps={{to:"/domains-for-sale"}} size="sm" variant='secondary' className="" style={{width: "60%", height: "100%"}} rightIcon={ArrowRightIcon}>
        <Typography variant={'button'}>View Details</Typography>
        </Button>
        <Button isLink={true} linkProps={{to:"/contact"}} size="sm" variant='primary-2' className="" style={{width: "40%", height: "100%"}}>
        <Typography variant={'button'}>Inquire</Typography>
        </Button>
      </div>
    </div>
  );
};

export default DomainCard;
